<!--
* UIID: UI-DLB-RMG-100
* UI Name: Repository List
* Modify Date: 2020/07/06
-->
<template>
  <div class="srm-list-container">
    <!-- Condition Search & Button -->
    <v-row class="custom-form-control custom-form-control-type-2">
      <v-col class="pb-0 pt-0" cols="12">
        <!-- Condition Search -->
        <v-row>
          <v-col class="comm-header-col data-query-section pb-0 pt-0" cols="12" lg="6">
            <v-row>
              <v-col cols="12" md="3" class="pt-0 pb-0">
                <v-autocomplete
                  v-model="masterSearchItems.data[0].CUST_ID"
                  :placeholder="$t('lbl.common.conditionSearch.selectCustomer')"
                  :items="customerItem"
                  @change="queryList"
                  class="custom-selectbox"
                  height="30"
                  hide-details
                  dense
                  solo
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="2" class="pt-0 pb-0">
                <v-text-field
                  v-model="masterSearchItems.data[0].MSG_SNDR"
                  :placeholder="$t('lbl.common.conditionSearch.findbySender')"
                  @keyup.enter="queryList"
                  hide-details
                  dense
                  solo
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" class="pt-0 pb-0">
                <v-text-field
                  v-model="masterSearchItems.data[0].MSG_RCVR"
                  :placeholder="$t('lbl.common.conditionSearch.findbyReceiver')"
                  @keyup.enter="queryList"
                  hide-details
                  dense
                  solo
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" class="pt-0 pb-0">
                <v-text-field
                  v-model="masterSearchItems.data[0].MSG_ID"
                  :placeholder="$t('lbl.common.conditionSearch.findbyMessage')"
                  @keyup.enter="queryList"
                  hide-details
                  dense
                  solo
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3" class="pt-0 pb-0 pr-24px">
                <v-autocomplete
                  v-model="masterSearchItems.data[0].PRCS_STS"
                  :items="srmStatusSearchArr"
                  :menu-props="{ offsetY: true }"
                  :placeholder="$t('lbl.common.conditionSearch.selectStatus')"
                  @change="queryList"
                  class="custom-selectbox"
                  hide-details
                  dense
                  solo
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            class="comm-header-col date-query-section pb-0 pt-0 pr-0 text-right"
            cols="12"
            lg="6"
          >
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-label>{{ $t("lbl.repositoryManager.updateDate") }}</v-label>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="fromdate_menu"
                v-model="fromdate_menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="masterSearchItems.init.FR_DAT"
                    :placeholder="$t('lbl.common.fromDate', [dateTimeFormat])"
                    :error-messages="masterSearchItems.init.FR_DAT_ERROR"
                    :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    @keypress="formatDate('from', $event)"
                    @change="changeDate('from')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="masterSearchItems.init.FR_DAT"
                  @input="fromdate_menu = false; changeDate('from')"
                  :max="getMaxDate"
                  class="date-period-picker"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="fromdate_menu = false">
                    {{$t("btn.common.cancel")}}
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.fromdate_menu.save(masterSearchItems.init.FR_DAT)"
                  >{{ $t("btn.common.ok") }}</v-btn>
                </v-date-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="todate_menu"
                v-model="todate_menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="masterSearchItems.init.TO_DAT"
                    :error-messages="masterSearchItems.init.TO_DAT_ERROR"
                    :placeholder="$t('lbl.common.toDate', [dateTimeFormat])"
                    :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    @keypress="formatDate('from', $event)"
                    @change="changeDate('to')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <!--203665 disable day after today  -->
                <v-date-picker
                  v-model="masterSearchItems.init.TO_DAT"
                  :min="getMinDate"
                  :allowed-dates="allowedDates"
                  @input="todate_menu = false; changeDate('to')"
                  class="date-period-picker"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="todate_menu = false">
                    {{$t("btn.common.cancel")}}
                  </v-btn>
                  <v-btn
                    @click="$refs.todate_menu.save(masterSearchItems.init.TO_DAT)"
                    text
                    color="primary"
                  >{{ $t("btn.common.ok") }}</v-btn>
                </v-date-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex btn-control">
              <div class="button-group-div">
                <v-btn
                  @click.native="queryList"
                  class="search-data-analysis-button btn-height-custom btn-width-1 btn-search primary mb-0"
                >
                  <v-icon x-small class="mr-2">fa fa-search</v-icon>
                  {{ $t("btn.common.search") }}
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- Button Action (Add/ Delete...)-->
    <!-- // 2021.11.26 203728 SPKA-274 modify paging -->
    <v-row class="custom-pagination-figma-v3-first">
      <v-col class="page-control-content page-control-bg">
        <v-row>
          <v-col lg="6" md="6">
            <v-row>
              <v-col class="page-control-bg" cols="12">
                <v-tooltip top :disabled="isDisableComMerge" :max-width="tooltipWidth">
                  <template v-slot:activator="{ on }">
                    <div v-on="on" class="btn-tooltip  mr-0">
                      <v-btn
                        :disabled="!isDisableComMerge"
                        @click="openMergeView"
                        class="btn btn-add"
                        color="#353f61"
                      >
                        {{ $t("btn.repositoryManager.repository.compareMerge") }}
                      </v-btn>
                    </div>
                  </template>
                  <span>
                    {{$t("msg.repositoryManager.repositoryTab.mergerCompareRepoTooltipMsg")}}
                  </span>
                </v-tooltip>
                <v-tooltip top :disabled="!isDisableSaveRepo" :max-width="tooltipWidth">
                  <template v-slot:activator="{ on }">
                    <div v-on="on" class="btn-tooltip  mr-0">
                      <v-btn
                        :disabled="isDisableSaveRepo"
                        @click="saveItems"
                        class="btn btn-add"
                      >
                        {{$t("btn.repositoryManager.repository.saveRepository")}}
                      </v-btn>
                    </div>
                  </template>
                  <span>
                    {{$t("msg.repositoryManager.repositoryTab.saveRepoTooltipMsg")}}
                  </span>
                </v-tooltip>
                <v-btn
                  class="btn btn-save"
                  @click="saveUpdateRow"
                >
                  {{ $t("btn.common.save") }}
                </v-btn>
                <v-tooltip top :disabled="!isEnableDelete" :max-width="tooltipWidth">
                  <template v-slot:activator="{ on }">
                    <div v-on="on" class="btn-tooltip">
                      <v-btn
                        :disabled="isEnableDelete"
                        @click="confirmDelete"
                        class="btn btn-delete"
                      >
                        {{ $t("btn.common.delete") }}
                      </v-btn>
                    </div>
                  </template>
                  <span>
                    {{$t("msg.repositoryManager.repositoryTab.deleteTooltipMsg")}}
                  </span>
                </v-tooltip>
              </v-col>
            </v-row>

          </v-col>
          <v-col lg="2" md="1"></v-col>
          <v-col lg="4" md="5" class="filter-search">
            <v-row>
              <v-col class="mr-0 pr-0" md="5">
                <v-select
                  v-model="searchBy"
                  :items="searchByItems"
                  :placeholder="$t('lbl.common.searchTypePlaceHolder')"
                  class="search-by data-table-select-box custom-selectbox flat-file-selectbox mr-0"
                  height="30"
                  hide-details
                  dense
                  solo
                ></v-select>
              </v-col>
              <v-col class="ml-0 pl-0" cols="12" md="7">
                <v-text-field
                  v-model="search"
                  :placeholder="$t('lbl.common.searchPlaceHolder')"
                  @input="onFilterRepository"
                  @click:append="onFilterRepository"
                  v-on:keyup.enter="onFilterRepository"
                  class="data-table-filter-text-field search-button-data-analysis-table"
                  heigth="30"
                  append-icon="fa fa-search"
                  outlined
                  hide-details
                  dense
                  solo
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- Grid table List -->
    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <v-table
          ref="repo_list_table"
          :key="componentKey"
          :isMinHeight="isMinHeight"
          :height="tableHeight"
          :title-rows="titleRows"
          :columns="columns"
          :table-data="repoList"
          :row-class-name="setRowClassName"
          :row-dblclick="rowDoubleClick"
          :row-height="35"
          :title-row-height="$vuetify.theme.dark ? 45 : 41"
          :class="
            $vuetify.theme.dark
              ? 'v-search-list-table-merge srm-list-table repo-list-table'
              : 'v-search-list-table-merge srm-list-table repo-list-table border-top'
          "
          :errorContent="'No matching records found'"
          :cell-merge="cellMerge"
          :select-all="selectAll"
          :select-change="selectChange"
          :multiple-sort="false"
          :after-update-callback="afterUpdateTable"
          :border-header-height="$vuetify.theme.dark ? 0 : 4"
          @sort-change="sortChange"
          width="100%"
          is-horizontal-resize
          :row-click="rowClick"
          :row-mouse-enter="rowEnter"
          :row-mouse-leave="rowLeave"
        >
          <template v-slot:custome="{ item }">
            <v-icon
              v-if="item.SYSSTATUS == 'I'"
              @click="deleteSRMRowItem(item)"
              x-small
              color="#CD5F5F"
            >fas fa-trash-alt</v-icon>
          </template>
          <template v-slot:MST_CUST_NM="{ item }">
            <span>{{ item.MST_CUST_NM }}</span>
          </template>
          <template v-slot:REPO_SNDR="{ item }">
            <v-text-field
              v-if="item.SYSSTATUS != ''"
              v-model="item.REPO_SNDR"
              :ref="'sndr_row_' + item.ROWID"
              class="data-table-filter-text-field search-button-data-analysis-table pt-1"
              autofocus
              heigth="30"
              placeholder="Enter the Sender"
              outlined
              hide-details
              dense
              solo
            ></v-text-field>
            <span v-if="item.SYSSTATUS == ''">{{ item.REPO_SNDR }}</span>
          </template>
          <template v-slot:REPO_RCVR="{ item }">
            <v-text-field
              v-if="item.SYSSTATUS != ''"
              v-model="item.REPO_RCVR"
              class="data-table-filter-text-field search-button-data-analysis-table pt-1"
              heigth="30"
              placeholder="Enter the Receiver"
              outlined
              hide-details
              dense
              solo
            ></v-text-field>
            <span v-if="item.SYSSTATUS == ''">{{ item.REPO_RCVR }}</span>
          </template>
          <template v-slot:REPO_MSG_ID="{ item }">
            <v-text-field
              v-if="item.SYSSTATUS != ''"
              v-model="item.REPO_MSG_ID"
              class="data-table-filter-text-field search-button-data-analysis-table pt-1"
              heigth="30"
              placeholder="Message"
              outlined
              hide-details
              dense
              solo
            ></v-text-field>
            <span v-if="item.SYSSTATUS == ''">{{ item.REPO_MSG_ID }}</span>
          </template>
          <template v-slot:REPO_PRCS_STS_NM="{ item }">
            <span
              :class="[
                srmStatusClass(item),
                'data-table-select-box',
                'srm-select-box',
                'custom-selectbox',
                'communication-select-box',
                'pt-1',
              ]"
            >{{ item.REPO_PRCS_STS_NM }}</span>
          </template>
          <template v-slot:SRM_COMM_TP="{ item }">
            <v-select
              v-model="item.SRM_COMM_TP"
              :items="communicationArr"
              @change="item.SYSSTATUS == 'I' ? '' : (item.SYSSTATUS = 'U')"
              class="data-table-select-box srm-select-box custom-selectbox communication-select-box pt-1"
              placeholder="Select"
              height="30"
              hide-details
              dense
              solo
              outlined
            ></v-select>
          </template>
          <template v-slot:ATF_FILE_NAME="{ item }">
            <div class="add-refe-file-col">
              <a class="download-attach-file-text" @click="downloadAttachFile(item)">
                {{item.ATF_FILE_CNT > 1 ? item.ATF_FILE_NAME+`(+${item.ATF_FILE_CNT - 1} ${item.ATF_FILE_CNT - 1 > 1 ? "Files" : "File"})`: item.ATF_FILE_NAME}}
              </a>
              <v-icon
                x-small
                @click="openAddReferenceFileDialog(item)"
                class="mr-2 ref-file-icon"
                color="#CD5F5F"
              >far fa-arrow-alt-circle-up</v-icon>
            </div>
          </template>
          <template v-slot:layout="{ item }">
            <a v-if="item.MAP_MSG_ID != null &&
                     item.MAP_MSG_VER != null &&
                     item.LAY_PRCS_NO != null"
                    @click="openLayoutView(item)"
            >{{ $t("btn.common.view") }}</a>
          </template>
          <template v-slot:merge_layout="{ item }">
            <a v-if="item.MAP_MSG_ID != null &&
                     item.MAP_MSG_VER != null &&
                     item.LAY_PRCS_NO != null"
                    @click="openLayoutView(item)"
            >{{ $t("btn.common.view") }}</a>
          </template>
          <template v-slot:merge_FFL_FILE_NAME="{ item }">
            <span class="font-weight-bold">{{ item.FFL_FILE_NAME }}</span>
          </template>
          <template v-slot:merge_MPD_FILE_NAME="{ item }">
            <span class="font-weight-bold">{{ item.MPD_FILE_NAME }}</span>
          </template>
          <template v-slot:merge_MAP_NAME="{ item }">
            <a
              v-if="
                item.MAP_NAME == '' ||
                  (item.MAP_NAME == null && item.REPO_PRCS_STS != 'INIT')
              "
              @click="openMapListDialog(item)"
              class="repo-link"
            >Select</a>
            <a v-if="item.MAP_NAME != '' &&
                    item.MAP_NAME != null &&
                    item.REPO_PRCS_STS != 'INIT'"
                    @click="openMapListDialog(item)"
            >{{ item.MAP_NAME }}</a>
            <span v-if="item.REPO_PRCS_STS == 'INIT'" class="font-weight-bold">{{ item.MAP_NAME }}</span>
          </template>
          <template v-slot:MAP_NAME="{ item }">
            <a v-if="item.MAP_NAME == '' ||
                  (item.MAP_NAME == null && item.REPO_PRCS_STS != 'INIT')"
                  @click="openMapListDialog(item)"
                  class="repo-link"
            >Select</a>
            <a v-if="item.MAP_NAME != '' &&
                    item.MAP_NAME != null &&
                    item.REPO_PRCS_STS != 'INIT'"
                    @click="openMapListDialog(item)"
            >{{ item.MAP_NAME }}</a>
            <span v-if="item.REPO_PRCS_STS == 'INIT'" class="font-weight-bold">{{ item.MAP_NAME }}</span>
          </template>
          <template v-slot:FFL_FILE_NAME="{ item }">
            <span class="font-weight-bold">{{ item.FFL_FILE_NAME }}</span>
          </template>
          <template v-slot:MPD_FILE_NAME="{ item }">
            <span class="font-weight-bold">{{ item.MPD_FILE_NAME }}</span>
          </template>
        </v-table>
      </v-col>
    </v-row>
    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <!-- Remove unuse code
        <analyzed-layout-dialog
        v-if="dialog.type == 'layoutView'"
        :params="params"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        class="analyzed-layout-dialog"
      ></analyzed-layout-dialog>

      <upload-fileview-dialog
        v-if="dialog.type == 'fileUploadView'"
        class="analyzed-layout-dialog width-1000"
        :edifile="edifile"
        :bizfile="bizfile"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
      ></upload-fileview-dialog>

      <edi-upload-dialog
        v-if="dialog.type == 'ediUploadFile'"
        class="custom-dialog dialog-small"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :queryList="queryList"
        :options="dialog.options"
      ></edi-upload-dialog>

      <merge-compare-dialog
        v-if="dialog.type == 'MergeCompare'"
        class="custom-dialog compare-merge-dialog"
        :params="params"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
      ></merge-compare-dialog> -->
      <map-list
        v-if="dialog.type == 'mapList'"
        class="maplist-layout-dialog"
        :id="dialog.id"
        ref="mapList"
        :closeDialog="removeDialog"
        :selectFile="loadMapList"
        :fileSelected="mapFile"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :queryList="repoList"
        :options="dialog.options"
        @openMapperVersion="openMapperVersion($event)"
        @openScannerVersion="openScannerVersion($event)"
        @inputSelectedMap="updatedMap($event)"
      ></map-list>
      <mapper-version-dialog
        v-if="dialog.type == 'mapperVersion'"
        class="custom-dialog mapper-version"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :reFreshList="reFreshList"
        :dialogCheckIn="openMapperListCheckIn"
        :versionList="mapperVersionHistoryItem"
        :options="dialog.options"
      ></mapper-version-dialog>
      <mapper-check-in-dialog
        v-if="dialog.type == 'mapperCheckIn'"
        class="custom-dialog mapper-version"
        :id="dialog.id"
        ref="mapperCheckIn"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :reFreshList="reFreshList"
        :versionList="mapperVersionHistoryItem"
        @openLoadFile="openLoadFile($event)"
        @openCodeTableDialog="openCodeTableDialog($event)"
        :options="dialog.options"
      ></mapper-check-in-dialog>
      <load-file-dialog
        v-if="dialog.type == 'loadFile'"
        class="load-file-dialog"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :prs="prs"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
      ></load-file-dialog>
      <selectCodeList
        v-if="dialog.type == 'selectCodeList'"
        class="maplist-layout-dialog mapbuilder-scanner-list codetable-list"
        :id="dialog.id"
        ref="selectCodeList"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        @selectCodeItem="selectCodeItem($event)"
      ></selectCodeList>
      <scanner-version-dialog
        v-if="dialog.type == 'scannerVersion'"
        class="custom-dialog mapper-version"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :reFreshList="reFreshList"
        :dialogCheckIn="openScannerListCheckIn"
        :versionList="mapperVersionHistoryItem"
        :options="dialog.options"
      ></scanner-version-dialog>
      <scanner-check-in-dialog
        v-if="dialog.type == 'scannerCheckIn'"
        class="custom-dialog mapper-version"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :reFreshList="reFreshList"
        :versionList="mapperVersionHistoryItem"
        :options="dialog.options"
        @openLoadFile="openLoadFile($event)"
      ></scanner-check-in-dialog>
      <addReferenceFile
        v-if="dialog.type == 'addReferenceFile'"
        class="addReferenceFile-layout-dialog"
        :id="dialog.id"
        ref="addReferenceFile"
        :caller="'repository'"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        @openReferenceFilesList="openReferenceList($event)"
        @reloadPage="queryList"
      ></addReferenceFile>
      <refenrenceFilesList
        v-if="dialog.type == 'refenrenceFilesList'"
        class="reference-files-list-layout-dialog"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        @inputSelectedFile="updatedReferenceFiles($event)"
      ></refenrenceFilesList>
    </div>
    <!-- 203665 Remove unuse source
    <dialogWindow
      ref="saveRepositoryInfoDialog"
      size="max"
      detail="There is no selected item"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="MergeLayoutCondition"
      size="max"
      title="Merge & Compare"
      color="validation"
      detail="There is no selected item"
    ></dialogWindow>
    <dialogWindow
      ref="deleteDialog"
      @select-ok="deleteRepository"
      size="max"
      title="Delete Repository Data"
      detail="Would you like remove this Items?"
      color="validation"
      show-cancel="true"
    ></dialogWindow>
    <dialogWindow
      ref="deleteWarningDialog"
      size="max"
      title="Warning"
      color="validation"
      detail="There is no selected item"
    ></dialogWindow>
    <dialogWindow
      ref="deleteSuccesssDialog"
      size="max"
      title="Delete Success"
      color="success"
      detail="Selected item has been deleted successfully."
      @select-ok="queryList"
    ></dialogWindow>
    -->
    <dialogWindow
      ref="saveRepositorySuccessDialog"
      size="max"
      color="success"
      detail="Selected item has been saved successfully."
    ></dialogWindow>
    <dialogWindow
      ref="confirmDeleteRepositoryDialog"
      @select-ok="deleteRepository"
      size="max"
      color="warning"
      detail="Are you sure want to delete these selected items(linked Mapper and all of EDI Asset)"
      show-cancel="true"
    ></dialogWindow>
    <dialogWindow
      ref="deleteRepositorySuccessDialog"
      size="max"
      color="success"
      detail="Selected item has been deleted successfully"
    ></dialogWindow>
    <dialogWindow
      ref="addNewRowEmptyDialog"
      size="max"
      title="Add New"
      detail="Sender, Receiver, Message cannot be empty"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="addNewRowDuplicateDialog"
      size="max"
      title="Add New"
      detail="Sender, Receiver, Message is already existed"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="SearchCondition"
      :detail="$t('msg.common.fromDateValidate')"
      size="max"
      title="Search"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="validateDate"
      size="max"
      :detail='$t("msg.common.validateDate")'
      color="validation"
    ></dialogWindow>
  </div>
</template>

<script>
/* globals Store */
/* Remove unuse code
import ghIcon from '@/vue-dlb/assets/github.svg?raw'
import browserIcon from '@/vue-dlb/assets/browser.svg?raw'
import dialogIcon from '@/vue-dlb/assets/dialog.svg?raw'
import downloadIcon from '@/vue-dlb/assets/download.svg?raw'
import ediUploadDialog from '@/vue-dlb/views/commons/EdiFileUpload.vue'
//import analyzedDialog from '@/vue-dlb/views/analysis/AnalyzedDialog.vue'
import uploadFileviewDialog from '@/vue-dlb/views/commons/UploadFileView.vue'
import mergeCompareDialog from '@/vue-dlb/views/matching/MergeCompareDialog.vue'
import { debounce } from "lodash";
import {
  showSuccessMessage,
  showErrorMessage,
  showProgress,
  hideProgress
} from "@/vue-dlb/utils/sys-util.js";
*/
import dialogWindow from '@/vue-dlb/components/NewDialog.vue'
import mapList from '@/vue-dlb/views/srm/MapList.vue'
import addReferenceFile from '@/vue-dlb/views/srm/AddReferenceFile.vue'
import refenrenceFilesList from '@/vue-dlb/views/srm/ReferenceFilesList.vue'
import { mapState } from "vuex";
import $ from "jquery";
import { deleteDateFormatStr } from '@/vue-dlb/utils/util';
import { beforeOneMonth } from '@/vue-dlb/utils/util';
import { getAppliedTimeZone } from '@/vue-dlb/utils/util';
import { dateValidation } from '@/vue-dlb/utils/util';
import cfg from '@/vue-caas/config/config.js'
import mapperVersionDialog from '@/vue-dlb/views/map/MapperVersionHistory.vue'
import mapperCheckInDialog from '@/vue-dlb/views/map/MapperCheckIn.vue'
import loadFileDialog from '@/vue-dlb/views/mapbuilder/LoadFile.vue'
import selectCodeList from '@/vue-dlb/views/commons/SelectCodeTable.vue'
import scannerVersionDialog from '@/vue-dlb/views/map/ScannerVersionHistory.vue'
import scannerCheckInDialog from '@/vue-dlb/views/map/ScannerCheckIn.vue'

export default {
  components: {
    // ediUploadDialog,
    // uploadFileviewDialog,
    // mergeCompareDialog,
    mapList,
    addReferenceFile,
    refenrenceFilesList,
    dialogWindow,
    mapperVersionDialog,
    mapperCheckInDialog,
    loadFileDialog,
    selectCodeList,
    scannerVersionDialog,
    scannerCheckInDialog
  },

  computed: {
    ...mapState("analysis", {
      masterItems: "masterItems",
      dataItems: "dataItems"
    }),
        // Phong 08/06/2020 SRM_List_Test Result fix Issue 23
    ...mapState("common", {
        codeList: "codeList"
    }),
    ...mapState("repository", {
      repoList: "repoList",
      repoListSource: "repoListSource",
      arrRepoFilter: "arrRepoFilter"
    }),
    // ...mapState("customer", {
    //  customerItems: "customerList"
    // }),
    // quickSearch: {
    //   get: function () {
    //     return this.quickSearchFilter;
    //   },
    //   set: function ( val ) {
    //     this.quickSearchFilter = val;
    //     this.quickSearchFilter && this.quickSearchList();
    //   }
    // },
    getMaxDate () {
      if (dateValidation(deleteDateFormatStr(this.masterSearchItems.init.FR_DAT), deleteDateFormatStr(this.masterSearchItems.init.TO_DAT))) {
        return getAppliedTimeZone();
      }
      else {
        this.$refs.SearchCondition.dialog = true;
        return getAppliedTimeZone();
      }
    },
    getMinDate () {
      if (dateValidation(deleteDateFormatStr(this.masterSearchItems.init.FR_DAT), deleteDateFormatStr(this.masterSearchItems.init.TO_DAT))) {
        return this.masterSearchItems.init.FR_DAT;
      }
      else {
        this.$refs.SearchCondition.dialog = true;
        return this.masterSearchItems.init.FR_DAT;
      }
    },
    //203665 Apply disable/enalble button and tooltip
    isDisableComMerge(){
      let mergeItem = this.selectRepoArr[0];
      if(this.selectRepoArr.length ==2 || this.selectRepoArr.length ==4){
        for(let i=0;i < this.selectRepoArr.length ; i++){
          if(this.selectRepoArr[i].REPO_PRCS_STS == "INIT"){
            return false;
          }else if(mergeItem.REPO_MSG_ID != this.selectRepoArr[i].REPO_MSG_ID){
            return false
          }
        }
        return true;
      }
      return false;
    },
    isDisableSaveRepo(){
      let cnt = 0;
      for(let i =0 ; i< this.selectRepoArr.length; i++){
         if(this.selectRepoArr[i].REPO_PRCS_STS == "INIT"){
           cnt ++;
         }
      }
      if(cnt >=1){
        return false;
      }
      return true;
    },
    isEnableDelete(){
      if(this.selectRepoArr.length > 0){
        return false;
      }
      return true;
    }
  },
  props: ['changeTab'],
  data(){
    return{
    //ACCESS_REPO_YN: '',   // common mandatory for ADMIN_YN
    /* Remove unuse code
    edifile: "",
    bizfile: "",
    fromDate: false,
    toDate: false,
    parmas: "",
    numberFormatter: new Intl.NumberFormat('en-US'),
    fromdate: null,
    todate: null,
    dialog2: false,
    SummaryList: {
      headers: [
        {text: '', value: 'checkbox'},
        {text: 'Sender', value: 'SRM_SNDR'},
        {text: 'Receiver', value: 'SRM_RCVR'},
        {text: 'Message', value: 'SRM_MSG_ID'},
        {text: 'Status', value: 'SRM_PRCS_STS', width: 200},
        {text: 'Layout', value: 'layout'},
        {text: 'Map', value: 'MAP_NAME'},
        {text: 'FlatFile Layout', value: 'FFL_FILE_NAME'},
        {text: 'Mapping Definition', value: 'MPD_FILE_NAME'},
        {text: 'Reference Files', value: 'ATF_FILE_NAME'},
        {text: 'Communication', value: 'SRM_COMM_TP'},
        {text: 'Create Date', value: 'SRM_CRE_DT', width: 200},
        {text: 'Update Date', value: 'SRM_UPD_DT', width: 200},
        {text: 'Create User', value: 'SRM_CRE_USR'},
        {text: 'Update User', value: 'SRM_UPD_USR'}
      ],
      selected: [],
    },
    SummDataList: {
      headers: [
        { text: 'File ID', value: 'MST_PRCS_NO' },
        { text: 'Sender', value: 'MST_MSG_SNDR' },
        { text: 'Receiver', value: 'MST_MSG_RCVR' },
        { text: 'Message', value: 'MST_MSG_ID' },
        { text: 'Version', value: 'MST_MSG_VER' },
        { text: 'Upload File', value: 'MST_INPT_FIL_NM' },
        { text: 'Upload Date', value: 'MST_UPD_DT' },
        { text: 'Transaction Date', value: 'MST_TRAN_DT' }
      ]
    },
    subGridSearchItems: {
      header: ['CUST_ID','MSG_SNDR','MSG_RCVR','MSG_ID','MSG_VER','DAT_TYPE','FR_DAT','TO_DAT'],
      data: [{
        CUST_ID: '',
        MSG_SNDR: '',
        MSG_RCVR: '',
        MSG_ID: '',
        MSG_VER: '',
        DAT_TYPE: '',
        FR_DAT: '',
        TO_DAT: ''
      }]
    },
    copyToMatchingItems: {
      header: ['CUST_ID','MSG_SNDR','MSG_RCVR','MSG_ID','MSG_VER','DAT_TYPE','FR_DAT','TO_DAT'],
      data: [{
        CUST_ID: '',
        MSG_SNDR: '',
        MSG_RCVR: '',
        MSG_ID: '',
        MSG_VER: '',
        DAT_TYPE: '',
        FR_DAT: '',
        TO_DAT: ''
      }]
    },
    messageFormatMap : {
      'E' : 'EDIFACT',
      'X' : 'ANSI X12'
    },
    dialogWidth: 400,
    styles: [
      { name: 'dialog-1'},
      { name: 'dialog-2'},
      { name: 'dialog-3'}
    ],
    style: null,
    icons: {
      gitHub: ghIcon,
      browser: browserIcon,
      download: downloadIcon,
      dialog: dialogIcon
    },
    app: process.env.APP,

    */
    fromdate_menu: false,
    maximumItem: 4,
    todate_menu: false,
    page: 1,
    pageCount: 0,
    itemsPerPage: -1,
    search: '',
    dialog: false,
    mapFile: '',
    tooltipWidth: 300,
    dateTimeFormat: '',
       // Phong 08/06/2020 SRM_List_Test Result fix Issue 23
    codeSearchItems: {
      header: ['GRP_CODE'],
      data: [{
        GRP_CODE:'',
      }],
    },
    columns: [
      {field: 'custome', width: 47, customSlot: true, checkShow : true, isShowSelect: (item) => { return item.SYSSTATUS != 'I' }, titleAlign: 'center',columnAlign:'center',type: 'selection', isFrozen:  true},
      {field: 'MST_CUST_NM', width: 100, customSlot: true, className:"font-weight-bold frozen-col-bg", columnAlign: 'left', isFrozen:  true},
      {field: 'REPO_SNDR', width: 100, customSlot: true, className:"sender-col frozen-col-bg", columnAlign: 'left', isFrozen:  true},
      {field: 'REPO_RCVR', width: 100, customSlot: true, className:"receiver-col frozen-col-bg", columnAlign: 'left', isFrozen:  true},
      {field: 'REPO_MSG_ID', width: 100, customSlot: true, className:"message-col frozen-col-bg", columnAlign: 'center', isFrozen:  true},
      {field: 'REPO_PRCS_STS_NM', width: 150, columnAlign: 'center', customSlot: true,  className:"frozen-col-bg", isResize: true,  isFrozen:  true},
      {field: 'layout', width: 93, className: "layout-col", customSlot: true, columnAlign: 'center'},
      {field: 'MAP_NAME', width: 200, className: "map-name-col", customSlot: true, columnAlign: 'left'},
      {field: 'FFL_FILE_NAME', width: 300, className: "font-weight-bold", columnAlign: 'left', customSlot: true},
      {field: 'MPD_FILE_NAME', width: 300, className: "font-weight-bold", columnAlign: 'left', customSlot: true},
      {field: 'ATF_FILE_NAME', width: 300, className: "map-name-col", customSlot: true, columnAlign: 'left'},
      {field: 'REPO_UPD_DT', width: 168, className: "update-date-col", columnAlign: 'center' },
      {field: 'REPO_UPD_USR', width: 158, className: "update-user-col", columnAlign: 'center' },
    ],
    titleRows: [[
      {fields: ['custome'], title: '', titleAlign: 'center'},
      {fields: ['MST_CUST_NM'], title: 'Customer', orderBy : '', titleAlign: 'center', newprop: 'newprop'},
      {fields: ['REPO_SNDR'], title: 'Sender', orderBy: '', titleAlign: 'center', newprop: 'newprop'},
      {fields: ['REPO_RCVR'], title: 'Receiver', titleAlign: 'center'},
      {fields: ['REPO_MSG_ID'], title: 'Message', titleAlign: 'center'},
      {fields: ['REPO_PRCS_STS_NM'], title: 'Status', titleAlign: 'center'},
      {fields: ['layout'], title: 'Layout', titleAlign: 'center'},
      {fields: ['MAP_NAME'], title: 'Map', titleAlign: 'center'},
      {fields: ['FFL_FILE_NAME'], title: 'FlatFile Layout', titleAlign: 'center'},
      {fields: ['MPD_FILE_NAME'], title: 'Mapping Definition', titleAlign: 'center'},
      {fields: ['ATF_FILE_NAME'], title: 'Reference Files', titleAlign: 'center'},
      {fields: ['REPO_UPD_DT'], title: 'Update Date', titleAlign: 'center'},
      {fields: ['REPO_UPD_USR'], title: 'Update User', titleAlign: 'center'}
      ]
    ],
    masterSearchItems: {
      header: ['ADMIN_YN', 'CUST_ID', 'OWNR_CUST_ID', 'MSG_SNDR','MSG_RCVR','MSG_ID','DAT_TYPE','FR_DAT','TO_DAT', 'PRCS_STS'],
      data: [{
        ADMIN_YN: '',
        CUST_ID: '',
        OWNR_CUST_ID: '',
        MSG_SNDR: '',
        MSG_RCVR: '',
        MSG_ID: '',
        DAT_TYPE: '',
        FR_DAT: '',
        TO_DAT: '',
        PRCS_STS: null
      }],
      init: {
        DAT_TYPE: 'UPDT',
        FR_DAT: beforeOneMonth(),
        TO_DAT: getAppliedTimeZone(),
        FR_DAT_PREV: beforeOneMonth(),
        TO_DAT_PREV: getAppliedTimeZone(),
        FR_DAT_ERROR: [],
        TO_DAT_ERROR: []
      }
    },
    openLayoutViewItems: {
      header: ['CUST_ID', 'OWNR_CUST_ID', 'STR_SNDR','STR_RCVR','MSG_STD','MSG_ID','MSG_VER','DAT_TYPE','FR_DAT','TO_DAT','MSG_CNT','MAP_NAME','FFL_FILE_NAME','MAP_CONV_TP'],
      data: [{
        CUST_ID: '',
        OWNR_CUST_ID: '',
        STR_SNDR: '',
        STR_RCVR: '',
        MSG_STD: '',
        MSG_ID: '',
        MSG_VER: '',
        DAT_TYPE: '',
        FR_DAT: '',
        TO_DAT: '',
        MSG_CNT: '',
        FFL_FILE_NAME: '',
        MAP_NAME:'',
        MAP_CONV_TP: ''
      }]
    },
    openMergeViewItems: {
      header: ['ADMIN_YN','CUST_ID','MSG_SNDR','MSG_RCVR','MSG_STD','MSG_ID','MSG_VER','LAY_PRCS_NO','ALIAS'],
      data: [],
    },
    saveItemsHeader: {
      header: ['ADMIN_YN', 'CUST_ID', 'OWNR_CUST_ID', 'LAY_PRCS_NO'],
      data: []
    },
    deleteRepoItems: {
      header: ['REPO_PRCS_NO','LAY_PRCS_NO'],
      data: []
    },
    deleteMapperItems: {
      header: ['MAP_PRCS_NO'],
      data: []
    },
    deleteFlatFileItems: {
      header: ['FFL_PRCS_NO'],
      data: []
    },
    deleteMappingDefinitionItems: {
      header: ['FFL_PRCS_NO'],
      data: []
    },
    deleteReferenceFileItems: {
      header: ['REPO_PRCS_NO'],
      data: []
    },
    downloadReferenceHeader: {
      header: ['MPD_PRCS_NO'],
      data: [
        {MPD_PRCS_NO: ''}
      ]
    },
    searchBy: '',
    searchByItems: [
      { text: 'All', value: 'all' },
      { text: 'Customer', value: 'MST_CUST_ID', },
      { text: 'Sender', value: 'REPO_SNDR' },
      { text: 'Receiver', value: 'REPO_RCVR' },
      { text: 'Message', value: 'REPO_MSG_ID' },
      { text: 'Map', value: 'MAP_NAME' },
      { text: 'Flatfile Layout', value: 'FFL_FILE_NAME' }
    ],
    saveUpdateItemsHeader: {
      header: ['REPO_PRCS_NO','MAP_PRCS_NO','REPO_SNDR','REPO_RCVR','REPO_MSG_ID'],
      data: [{
        REPO_PRCS_NO: '',
        MAP_PRCS_NO: '',
        REPO_SNDR: '',
        REPO_RCVR: '',
        REPO_MSG_ID: '',
      }]
    },
    selectedMasterItem : {},
    arrLayoutDialog: [],
    dialogs: [],
    senders: [],
    // Phong 08/06/2020 SRM_List_Test Result fix Issue 23
    dateTypes:[],
    dialogId: 1,
    selected: null,
    selectMasterRows: [],
    layoutViewArr: [],
    uploadFileViewArr: [],
    statusStatArr: [],
    selectRepoArr: [],
    mapperVersionHistoryItem: null,
     // Phong 08/06/2020 SRM_List_Test Result fix Issue 23
    communicationArr: [],
    srmStatusArr: [],
    srmStatusSearchArr: [
      {text: 'All', value:''}
    ],
    customerItem:[
      {text: 'All', value: ''}
    ],
    isMinHeight:true,
    tableHeight:600,
    componentKey:0,
    window: {
      width: 0,
      height: 0
    },
    // 2021.9.9 203728 SPKA-199 Change background when hover,click row in v-table
    rowCurrentClick: -1,
    listFrozen: ['MST_CUST_NM', 'REPO_SNDR', 'REPO_RCVR', 'REPO_MSG_ID', 'REPO_PRCS_STS_NM'],
  }},
  watch: {
    changeTab(){
      if(this.changeTab!=0){
        this.queryList();
      }
    },
    // mainGrid: function(datarows) {
    // },
    // statusList: function(data) {
    //   this.statusStatArr = [];
    //   for (let i = 0; i < data.length; i++) {
    //     let item = {};
    //     let status = data[i];
    //     let code = status.SRM_PRCS_STS;
    //     let name = status.SRM_PRCS_STS_NM;
    //     if (code == 'DELE') {
    //       continue;
    //     }
    //     if (code == 'SL') {
    //       name = 'Initialized';
    //     }
    //     item.value = code;
    //     item.name = name;
    //     item.count = status.CNT;
    //     item.color = '';
    //     item.class = `srm-${name.replace(' ', '').toLowerCase()}-status`;
    //     if (code == 'SL') {
    //       item.class = 'srm-init-status';
    //     }
    //     this.statusStatArr.push(item);
    //   }
    // },
    '$vuetify.theme.dark': function(){
      let overflow = $('.v-scrollbar-wrap').css('overflow-x');
      if (overflow == 'scroll') {
        $('.v-scrollbar-wrap').css('overflow-x', 'auto');
      } else {
        $('.v-scrollbar-wrap').css('overflow-x', 'scroll');
      }
    }
  },
  methods: {
    validateDateInput(dateString) {
      var regEx = /^\d{4}-\d{2}-\d{2}$/;
      if(!dateString.match(regEx)) return false;  // Invalid format
      var d = new Date(dateString);
      var dNum = d.getTime();
      if(!dNum && dNum !== 0) return false; // NaN value, Invalid date
      return d.toISOString().slice(0,10) === dateString;
    },
    formatDate(side, evt) {
      let dateString = (side === 'from') ? this.masterSearchItems.init.FR_DAT: this.masterSearchItems.init.TO_DAT
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 45) {
        evt.preventDefault();
      } else if ((charCode !== 46 && charCode !== 8 && charCode !== 45 &&  dateString.length === 4 && !dateString.includes("-")) || 
      (charCode !== 46 && charCode !== 8 && charCode !== 45 &&  dateString.length === 7 && dateString[4] === '-' && ((dateString.match(/-/g) || []).length == 1))) {
        dateString += '-';
        (side === 'from') ? (this.masterSearchItems.init.FR_DAT = dateString) : (this.masterSearchItems.init.TO_DAT = dateString)
      } else {
        return true;
      }
    },
    changeDate(side) {
      if (side === 'from') {
        if(!this.validateDateInput(this.masterSearchItems.init.FR_DAT)) {
          this.$refs.validateDate.dialog = true;
          this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
          this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
          return;
        }
        if (this.masterSearchItems.init.FR_DAT > getAppliedTimeZone()) {
          this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
        }
        if (this.masterSearchItems.init.FR_DAT > this.masterSearchItems.init.TO_DAT) {
          this.masterSearchItems.init.TO_DAT = this.masterSearchItems.init.FR_DAT
        }
      }
      if (side === 'to') {
        if(!this.validateDateInput(this.masterSearchItems.init.TO_DAT)) {
          this.$refs.validateDate.dialog = true;
          this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
          this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
          return;
        }
        if (this.masterSearchItems.init.TO_DAT > getAppliedTimeZone()) {
          this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
        }
        if (this.masterSearchItems.init.FR_DAT > this.masterSearchItems.init.TO_DAT) {
          this.masterSearchItems.init.FR_DAT = this.masterSearchItems.init.TO_DAT
        }
      }
    },
    // 2021.9.89 203728 SPKA-199 Change background when hover,click row in v-table
    rowClick(rowIndex, rowData){
      this.listFrozen.map(e => {
        $('#' + e + this.rowCurrentClick).removeClass('custom-row-click-v-table');
        $('#' + e + rowIndex).addClass('custom-row-click-v-table');
      })
      this.rowCurrentClick = rowIndex;
    },
    rowEnter(rowIndex){
      this.listFrozen.map(e => {
        $('#' + e + rowIndex).addClass('custom-row-click-v-table');
      })
    },
    rowLeave(rowIndex){
      if(this.rowCurrentClick !== rowIndex){
        this.listFrozen.map(e => {
          $('#' + e + rowIndex).removeClass('custom-row-click-v-table');
        })
      }
    },
    sortChange(data) {
      let keys = Object.keys(data);
      for (let i = 0; i < keys.length; i++) {
        let col = keys[i];
        let sort = data[col];
        if (sort != "") {
          Store.commit('repository/sortRepoList', {col, sort});
          return;
        }
      }
    },
    selectChange(selection, rowdata) {
      this.selectRepoArr = selection;
    },
    selectAll(selection) {
      this.selectRepoArr = selection;
    },
    // Phong 08/06/2020 SRM_List_Test Result fix Issue 23
    getStatus(){
      this.codeSearchItems.data[0].GRP_CODE ="C01";
      Store.dispatch("common/getCode", this.codeSearchItems).then(() => {
        console.log("--------- Finished to process Status List ----------");
        for(let i=0;i< this.codeList.length;i++){
        let codeObj= {};
        codeObj.text= this.codeList[i].CM_CODE_NAME;
        codeObj.value= this.codeList[i].CM_CODE_ID;
        this.srmStatusSearchArr.push(codeObj);
        this.srmStatusArr.push(codeObj);
        }
      });
    },
    getCustomers(){
      this.$store.dispatch('getCompanyList').then(()=>{
        console.log("--------- Finished to process Customer List ----------");
        this.$store.getters.companies.forEach(element => {
          let codeObj = {};
          codeObj.text = element.compNm;
          codeObj.value = element.compId;
          this.customerItem.push(codeObj);
        });
      });
    },
    getStatusText(status) {
      for (let i = 0; i < this.srmStatusArr.length; i++) {
        let item = this.srmStatusArr[i];
        if (item.value == status) {
          return item.text;
        }
      }
      return '';
    },
    getDateType(){
      this.codeSearchItems.data[0].GRP_CODE ="A06";
      Store.dispatch("common/getCode", this.codeSearchItems).then(() => {
        console.log("--------- Finished to process Date Type ----------");
        for(let i=0;i< this.codeList.length;i++){
        let codeObj= {};
        codeObj.text= this.codeList[i].CM_CODE_NAME;
        codeObj.value= this.codeList[i].CM_CODE_ID+'T';
        this.dateTypes.push(codeObj);
        }
      });
    },
    getCommunication(){
      this.codeSearchItems.data[0].GRP_CODE ="A07";
      Store.dispatch("common/getCode", this.codeSearchItems).then(() => {
        console.log("--------- Finished to process Communication ----------");
        for(let i=0;i< this.codeList.length;i++){
        let codeObj= {};
        codeObj.text= this.codeList[i].CM_CODE_NAME;
        codeObj.value= this.codeList[i].CM_CODE_ID;
        this.communicationArr.push(codeObj);
        }
      });
    },
    queryList () {
      //[2020-04-15] apply by CLV: Apply srmlist/queryList api
      if (dateValidation(deleteDateFormatStr(this.masterSearchItems.init.FR_DAT), deleteDateFormatStr(this.masterSearchItems.init.TO_DAT))) {
        console.log("--------- getSummaryList ----------");
        console.log("before fromdate(" + this.masterSearchItems.init.FR_DAT + ")");
        this.masterSearchItems.data[0].FR_DAT = deleteDateFormatStr(this.masterSearchItems.init.FR_DAT);
        console.log("after fromdate(" + this.masterSearchItems.data[0].FR_DAT + ")");
        this.masterSearchItems.data[0].TO_DAT = deleteDateFormatStr(this.masterSearchItems.init.TO_DAT);
        this.masterSearchItems.data[0].ADMIN_YN = $cookies.get('used-repo');
        if(!['Y', 'YY', 'NY'].includes($cookies.get('used-repo'))){
          //this.masterSearchItems.data[0].CUST_ID = $cookies.get('comp-id');
          this.masterSearchItems.data[0].OWNR_CUST_ID =  $cookies.get('ownr-id');
        }
        this.masterSearchItems.data[0].DAT_TYPE = this.masterSearchItems.init.DAT_TYPE;
        Store.dispatch("repository/queryRepoList", this.masterSearchItems).then(() => {
          console.log("--------- Finished to process ----------");
          this.selectMasterRows = [];
          this.selectRepoArr =[];
        });
        // this.quickSearch = "";
      } else {
        this.$refs.SearchCondition.dialog = true;
      }
    },

    /*  Remove unuse code
    viewSummDataList (event, selItem) {
      this.selectedMasterItem = selItem;
      console.log("--------- viewSummDataList ----------");
      this.subGridSearchItems.data[0].CUST_ID = $cookies.get('comp-id');
      this.subGridSearchItems.data[0].MSG_SNDR  = selItem.MST_MSG_SNDR;
      this.subGridSearchItems.data[0].MSG_RCVR  = selItem.MST_MSG_RCVR;
      this.subGridSearchItems.data[0].MSG_ID  = selItem.MST_MSG_ID;
      this.subGridSearchItems.data[0].MSG_VER  = selItem.MST_MSG_VER;
      this.subGridSearchItems.data[0].DAT_TYPE  = this.masterSearchItems.data[0].DAT_TYPE;
      this.subGridSearchItems.data[0].FR_DAT = this.masterSearchItems.data[0].FR_DAT;
      this.subGridSearchItems.data[0].TO_DAT = this.masterSearchItems.data[0].TO_DAT;

      Store.dispatch("analysis/getSummaryDataList", this.subGridSearchItems).then(() => {
        console.log("--------- Finished to process ----------");
      });
    },
    viewFile (item) {
      let index = this.findIndexItem(item, this.uploadFileViewArr, 'ROWID');
      if (index != null) {
        return;
      }

      this.params =  {
        edifile : item.MST_INPT_FIL_NM,
        bizfile : item.MST_BIZ_FIL_NM,
        ROWID : item.ROWID.toString()
      };

      this.uploadFileViewArr.push(item);
      Store.commit('analysis/SET_FILEVIEW_WINDOW_PARAM', Object.assign({}, this.params));

      var w = window.open(`/edimanager/UploadFileView/${item.ROWID}`, '_blank', "width=1000,height=750,left=100,top=30");
      w.params = this.params;
      w.closePopup = () => {
        let index = this.findIndexItem(item, this.uploadFileViewArr, 'ROWID');
        this.uploadFileViewArr.splice(index, 1);
        Store.commit('analysis/DELETE_FILEVIEW_WINDOW_PARAM', Object.assign({}, this.params));
        w.close();
      }
      if (typeof window.fileViewOpenWindow == 'undefined') {
        window.fileViewOpenWindow = {[item.ROWID.toString()] : w.closePopup};
      } else {
        window.fileViewOpenWindow[item.ROWID.toString()] = w.closePopup;
      }
      w.onbeforeunload = w.closePopup;
    },

    formatNumber(num) {
      return this.numberFormatter.format(num);
    },
    copyToMatching() {
      // add by April
      // Plz set all of the rows what selected from first grid
      this.copyToMatchingItems.data = [];
      for(let i = 0; i < this.selectMasterRows.length; i++) {
        let item = this.selectMasterRows[i];
        this.copyToMatchingItems.data.push({
          CUST_ID : `${this.$cookies.get('comp-id')}`,
          MSG_SNDR : item.MST_MSG_SNDR,
          MSG_RCVR : item.MST_MSG_RCVR,
          MSG_ID : item.MST_MSG_ID,
          MSG_VER : item.MST_MSG_VER,
          DT_TYPE : this.masterSearchItems.data[0].DAT_TYPE,
          FR_DAT : this.masterSearchItems.data[0].FR_DAT,
          TO_DAT : this.masterSearchItems.data[0].TO_DAT
        })
      }

      Store.dispatch("analysis/copyToMatching", this.copyToMatchingItems).then(() => {
        console.log("--------- Finished to process ----------");
      });
    },
    generateExcelFile() {
      let self = this;
      const excel = require('node-excel-export');

      // You can define styles as json object
      const styles = {
        headerDark: {
          fill: {
            fgColor: {
              rgb: 'FF496D94'
            }
          },
          font: {
            color: {
              rgb: 'FFFFFFFF'
            },
            sz: 14,
          }
        }
      };

      //Here you specify the export structure
      const specification = {
        SRM_SNDR: { // <- the key should match the actual data key
          displayName: 'Sender', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120 // <- width in pixels
        },
        SRM_RCVR: { // <- the key should match the actual data key
          displayName: 'Receiver', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120 // <- width in pixels
        },
        SRM_MSG_ID: { // <- the key should match the actual data key
          displayName: 'Message', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120 // <- width in pixels
        },
        SRM_PRCS_STS: { // <- the key should match the actual data key
          displayName: 'Status', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          cellFormat: function(value, row) { // <- Renderer function, you can access also any row.property
            let item = self.srmStatusArr.find((item) => { return item.value == value})
            return item ? item.text : '';
          },
          width: 120 // <- width in pixels
        },
        MAP_NAME: { // <- the key should match the actual data key
          displayName: 'Map', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120 // <- width in pixels
        },
        FFL_FILE_NAME: { // <- the key should match the actual data key
          displayName: 'FlatFile Layout', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120 // <- width in pixels
        },
        MPD_FILE_NAME: { // <- the key should match the actual data key
          displayName: 'Mapping Definition', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120 // <- width in pixels
        },
        ATF_FILE_NAME: { // <- the key should match the actual data key
          displayName: 'Reference Files', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120 // <- width in pixels
        },
        SRM_COMM_TP: { // <- the key should match the actual data key
          displayName: 'Communication', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          cellFormat: function(value, row) { // <- Renderer function, you can access also any row.property
            let item = self.communicationArr.find((item) => { return item.value == value})
            return item ? item.text : '';
          },
          width: 120 // <- width in pixels
        },
        SRM_CRE_DT: { // <- the key should match the actual data key
          displayName: 'Create Date', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120 // <- width in pixels
        },
        SRM_UPD_DT: { // <- the key should match the actual data key
          displayName: 'Update Date', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120 // <- width in pixels
        },
        SRM_CRE_USR: { // <- the key should match the actual data key
          displayName: 'Create User', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120 // <- width in pixels
        },
        SRM_UPD_USR: { // <- the key should match the actual data key
          displayName: 'Update User', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 120 // <- width in pixels
        },

      }

      // Create the excel report.
      // This function will return Buffer
      const report = excel.buildExport(
        [ // <- Notice that this is an array. Pass multiple sheets to create multi sheet report
          {
            name: 'Report', // <- Specify sheet name (optional)
            heading: [], // <- Raw heading array (optional)
            merges: [], // <- Merge cell ranges
            specification: specification, // <- Report specification
            data: this.mainGrid // <-- Report data
          }
        ]
      );

      var data = new Blob([report.buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
      var url = window.URL.createObjectURL(data);
      var a = document.createElement("a");
        a.href = url;
        a.download = 'SRMList.xlsx';
        document.body.appendChild(a);
        a.click();
    },
    resetStatusStatArr() {
      for(let i = 0; i < this.statusStatArr.length; i++) {
        let stat = this.statusStatArr[i];
        stat.count = 0;
      }
    },

    increaseStatusStat(value) {
      for(let i = 0; i < this.statusStatArr.length; i++) {
        let stat = this.statusStatArr[i];
        if (stat.value == value) {
          stat.count += 1;
        }
      }
    },
    changeFromDate(str) {
      if (!this.checkPeriod()) {
        this.masterSearchItems.init.FR_DAT = this.masterSearchItems.init.FR_DAT_PREV;
        this.$refs.SearchCondition.dialog = true;
      } else {
        this.masterSearchItems.init.FR_DAT_PREV = str;
      }
    },

    changeToDate(str) {
      if (!this.checkPeriod()) {
        this.masterSearchItems.init.TO_DAT = this.masterSearchItems.init.TO_DAT_PREV;
        this.$refs.SearchCondition.dialog = true;
      } else {
        this.masterSearchItems.init.TO_DAT_PREV = str;
      }
    },

    checkPeriod() {
      let fromDate = new Date(this.masterSearchItems.init.FR_DAT);
      let toDate = new Date(this.masterSearchItems.init.TO_DAT);
      let maxDate = new Date(fromDate);
      maxDate.setMonth(maxDate.getMonth() + 6);
      if (toDate.getTime() < fromDate.getTime() || toDate.getTime() > maxDate.getTime() ) {
        return false;
      }
      return true;
    },
    selectAllChange(value) {
      let maxItem = this.maximumItem;
      let checkFlg = true;
      let selectAllItems = [];
      if(value && maxItem >= this.masterItems.length ){
        for (let i = 0; i < this.masterItems.length; i++) {
          let item = this.masterItems[i];
          if (item.MST_MSG_ID != this.masterItems[0].MST_MSG_ID) {
            checkFlg = false;
            this.$refs.warningDialog.dialog = true;
            break;
          }
        }
        if(checkFlg){
          for (let i = 0; i < this.masterItems.length; i++) {
            let item = this.masterItems[i];
            item.checked = value;
            selectAllItems.push(item);
          }
          this.selectMasterRows = selectAllItems;
        }
      }else if(value){
        this.$refs.mergeCompareInfoDialog.dialog = true;
      }else{
        for (let i = 0; i < this.masterItems.length; i++) {
          let item = this.masterItems[i];
          item.checked = false;
        }
        this.selectMasterRows = [];
      }
    },
    checkMessageType(item){
      if(this.selectMasterRows[0].MST_MSG_ID != item.MST_MSG_ID){
        this.$refs.warningDialog.dialog = true;
        return false
      }
      this.selectMasterRows.push(item);
      return true
    },
    selectItemChange(event, item) {
      let maxItem = this.maximumItem;
      let checked = item.checked;
      if (checked == true) {
        if (0 < this.selectMasterRows.length && maxItem > this.selectMasterRows.length) {
          item.checked = this.checkMessageType(item);
        }
        else if ((maxItem - 1) < this.selectMasterRows.length) {
          item.checked = false;
          this.$refs.mergeCompareInfoDialog.dialog = true;
        }
        else if (this.selectMasterRows.length == 0){
          this.selectMasterRows.push(item);
        }
      } else if (checked == false) {
        let index = this.findIndexItem(item, this.selectMasterRows, 'ROWID');
        if (index != null) {
          this.selectMasterRows.splice(index, 1);
        }
      }
    },
    openDialog () {
      let type = "ediUploadFile";
      let item = {
        ROWID : 0
      }
      let indexArrDialog = this.findDialog("ediUploadFile_0");
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    addRowSRMList() {
      let newRow = {
        'ROWID': this.getMaxRowID(),
        'SRM_SNDR' : '',
        'SRM_RCVR' : '',
        'SRM_MSG_ID' : '',
        'SRM_PRCS_STS' : 'ADDED',
        'layout' : '',
        'MAP_NAME' : '',
        'FFL_FILE_NAME' : '',
        'MPD_FILE_NAME' : '',
        'ATF_FILE_NAME' : '',
        'SRM_COMM_TP' : '',
        'SRM_CRE_DT' : '',
        'SRM_UPD_DT' : '',
        'SRM_CRE_USR' : '',
        'SRM_UPD_USR' : '',
        'SYSSTATUS': 'I'
      }

      this.mainGrid.push(newRow);
      setTimeout(()=> {
        $('html').scrollTop($('html').height());
        $('.srm-list-table .v-scrollbar-wrap').scrollTop(this.mainGrid.length * 40);
      }, 300);
    },
      selectStatus(status) {
        for (let i = 0; i < this.mainGridSource.length; i++) {
          let srmItem = this.mainGridSource[i];
          if (srmItem['SRM_PRCS_STS'] != status.value) {
            srmItem.hidden = true;
          } else {
            srmItem.hidden = false;
          }
        }
        this.$refs.srm_list_table.$forceUpdate();
        Store.commit('srmlist/mainGridFilter', this.mainGridSource);
      },
      getMaxRowID() {
        let maxRowID = 1;
        for (let i = 0; i < this.mainGrid.length; i++) {
          if (maxRowID <= this.mainGrid[i].ROWID) {
            maxRowID = this.mainGrid[i].ROWID + 1;
          }
        }
        return maxRowID;
      },
       addCustomerItem(){
      for(let i=0;i< this.customerItems.length;i++){
        let customerObj =[];
        customerObj.text = this.customerItems[i].MST_CUST_NAME;
        customerObj.value = this.customerItems[i].MST_CUST_ID;
        this.customerItem.push(customerObj);
      }
    },
    */

    srmStatusClass(item) {
      if(typeof item.REPO_PRCS_STS == 'string') {
        return `repo-${item.REPO_PRCS_STS.toLowerCase()}-status`;
      }
    },
    afterUpdateTable() {
      setTimeout(() => {
        let scrollbar = $('.v-scrollbar-wrap').first();
        let scrolltop = scrollbar.scrollTop();
        scrollbar.scrollTop(scrolltop - 1);
        scrollbar.scrollTop(scrolltop + 1);
        scrollbar.scrollTop(scrolltop);
      }, 3);
    },

    cellMerge(rowIndex,rowData,field){
      if (field == 'custome' || field == 'layout' || field == 'MAP_NAME' || field == 'FFL_FILE_NAME' || field == 'MPD_FILE_NAME') {
        let filters = this.arrRepoFilter.filter((item) => {
          return item.index == rowIndex;
        });
        if (filters.length == 1) {
          let filter = filters[0];
          return {
              colSpan: 1,
              rowSpan: filter.count,
              content: '',
              componentName: ''
          }
        }
      }
    },

    openLayoutView(item) {
      let index = this.layoutViewArr.findIndex(e => e.ROWID === item.ROWID);
      if (index > -1) return window.layoutFocus[item.ROWID]();

      this.openLayoutViewItems.data[0].CUST_ID  = $cookies.get('comp-id');
      this.openLayoutViewItems.data[0].OWNR_CUST_ID  = $cookies.get('ownr-id');
      this.openLayoutViewItems.data[0].MSG_STD  = item.LAY_MSG_STD;
      this.openLayoutViewItems.data[0].MSG_ID  = item.MAP_MSG_ID;
      this.openLayoutViewItems.data[0].MAP_NAME  = item.MAP_NAME;
      this.openLayoutViewItems.data[0].MAP_CONV_TP  = item.MAP_CONV_TP;
      this.openLayoutViewItems.data[0].FFL_FILE_NAME  = item.FFL_FILE_NAME;
      this.openLayoutViewItems.data[0].FFL_FRMT_TP  = item.FFL_FRMT_TP;
      this.openLayoutViewItems.data[0].MSG_VER  = item.MAP_MSG_VER;
      this.openLayoutViewItems.data[0].STR_SNDR =  item.REPO_SNDR;
      this.openLayoutViewItems.data[0].STR_RCVR =  item.REPO_RCVR;
      this.openLayoutViewItems.data[0].MSG_CNT = item.ATF_FILE_CNT;
      this.openLayoutViewItems.data[0].DAT_TYPE  = this.masterSearchItems.data[0].DAT_TYPE;
      this.openLayoutViewItems.data[0].FR_DAT = this.masterSearchItems.data[0].FR_DAT;
      this.openLayoutViewItems.data[0].TO_DAT = this.masterSearchItems.data[0].TO_DAT;
      this.openLayoutViewItems.data[0].PRCS_STS = item.REPO_PRCS_STS;
      this.openLayoutViewItems.data[0].LAY_PRCS_NO = item.LAY_PRCS_NO;
      this.openLayoutViewItems.data[0].SRM_PRCS_NO = item.REPO_PRCS_NO;
      this.openLayoutViewItems.data[0].ALIAS = '';
      this.openLayoutViewItems.data[0].ROWID = item.ROWID;
      this.params = this.openLayoutViewItems.data[0];
      this.layoutViewArr.push(item);
      Store.commit('layout/SET_LAYOUT_WINDOW_PARAM', Object.assign({}, this.params));
      var w = window.open(`/edimanager/EdiAnalyzedView_SRM/${item.ROWID}`, '_blank', "width=1550,height=800,left=100,top=30");
      w.mode = "RepositoryLayoutView"
      w.params = this.params;
      // 20218.7.13 203728 SPKA-153 close new window expired.
      w.newWindowExpire = true;
      if(this.$vuetify.theme.isDark == true){
            w.theme = this.$vuetify.theme.isDark;
      }
      w.parent = this;// 2021.4.12 203728 SPKA-52 => bug 16
      w.closePopup = () => {
        let index = w.parent.findIndexItem(item, w.parent.layoutViewArr, 'ROWID');
        w.parent.layoutViewArr.splice(index, 1);
        Store.commit('layout/DELETE_LAYOUT_WINDOW_PARAM', Object.assign({}, w.parent.params));
        w.close();
        w.parent.queryList();
      }
      w.focusPopup = () => {
        w.focus();
      }
      if (typeof window.layoutOpenWindow == 'undefined' || typeof window.layoutFocus == 'undefined') {
        window.layoutOpenWindow = {[item.ROWID.toString()] : w.closePopup};
        window.layoutFocus = {[item.ROWID.toString()] : w.focusPopup};
      } else {
        window.layoutOpenWindow[item.ROWID.toString()] = w.closePopup;
        window.layoutFocus[item.ROWID.toString()] = w.focusPopup;
      }
      w.onbeforeunload = w.closePopup;
    },

    openMergeView() {
      // 203665 Apply disable/enalble button and tooltip
      this.openMergeViewItems.data = [];
      let mergeItem = this.selectRepoArr[0];
      for(var i = 0; i <this.selectRepoArr.length; i++){
        this.openMergeViewItems.data[i] = {
          ADMIN_YN: $cookies.get('used-repo'),
          CUST_ID : $cookies.get('comp-id'),
          MSG_SNDR: `${this.selectRepoArr[i].REPO_SNDR}`,
          MSG_RCVR:`${this.selectRepoArr[i].REPO_RCVR}`,
          MSG_STD:'',
          MSG_ID: `${this.selectRepoArr[i].MAP_MSG_ID}`,
          MSG_VER:`${this.selectRepoArr[i].MAP_MSG_VER}`,
          LAY_PRCS_NO:  `${this.selectRepoArr[i].LAY_PRCS_NO}`,
          ALIAS: `ALIAS_${this.selectRepoArr[i].ROWID}`,
        };
      }
      this.params = this.openMergeViewItems.data;
      let querystring = 'popup=true&';
      if(this.$vuetify.theme.isDark == true){
        querystring += 'theme=Dark'
      } else {
        querystring += 'theme=Light'
      }
      var w = window.open(`/edimanager/AnalysisCompareMerge?${querystring}`, '_blank', "width=1825,height=800,left=100,top=100");
      w.params = this.params;
      // 20218.7.13 203728 SPKA-153 close new window expired.
      w.newWindowExpire = true;
      w.mode = "RepositoryMergeView"
      w.pageTitle = "Compare & Merge"
      w.theme = false;
      if(this.$vuetify.theme.isDark == true){
        w.theme = this.$vuetify.theme.isDark;
      }
      w.parent = this;// 2021.4.12 203728 SPKA-52 => bug 16
      w.closePopup = () => {
        w.close();
        for (let i = 0; i < w.parent.selectRepoArr.length; i++) {
          w.parent.selectRepoArr[i]._checked = false;
        }
        w.parent.$refs.repo_list_table.updateCheckboxStatus();
        w.parent.selectRepoArr = [];
      }

      if (typeof window.mergeOpenWindow == 'undefined') {
        window.mergeOpenWindow = {'close' : w.closePopup};
      } else {
        window.mergeOpenWindow['close'] = w.closePopup;
      }
      w.onbeforeunload = w.closePopup;
    },
    saveItems() {
      //203665 Apply disable/enalble button and tooltip
      this.saveItemsHeader['data'] = [];
      for(let i = 0; i < this.selectRepoArr.length; i++) {
        let item = this.selectRepoArr[i];
        if (item.LAY_PRCS_NO != null && item.LAY_PRCS_NO != '') {
          this.saveItemsHeader.data.push(
            {
              ADMIN_YN: $cookies.get('used-repo'),
              CUST_ID: item.MST_CUST_ID,
              OWNR_CUST_ID : item.OWNR_CUST_ID,
              LAY_PRCS_NO: item.LAY_PRCS_NO
            }
          )
        }
      }
      if (this.saveItemsHeader['data'].length > 0) {
        Store.dispatch("repository/saveRepository", this.saveItemsHeader).then(() => {
          console.log("--------- Finished to process ----------");
          this.queryList();
          this.selectRepoArr =[];
          this.$refs.saveRepositorySuccessDialog.dialog = true;
        });
      }
    },
    confirmDelete(){
      this.$refs.confirmDeleteRepositoryDialog.dialog = true;
    },
    deleteRepository(){
      this.deleteRepoItems['data'] = [];
      for(let i = 0; i < this.selectRepoArr.length; i++) {
        let item = this.selectRepoArr[i];
        this.deleteRepoItems.data.push(
          {
            REPO_PRCS_NO: item.REPO_PRCS_NO,
            LAY_PRCS_NO: item.LAY_PRCS_NO
          }
        )
        if (item.MAP_PRCS_STS === 'REPO') {
          if (item.MAP_PRCS_NO != '' && item.MAP_PRCS_NO != null) {
            this.deleteMapperItems.data.push(
              {
                MAP_PRCS_NO: item.MAP_PRCS_NO,
              }
            )
          }

          if (item.FFL_PRCS_NO != '' && item.FFL_PRCS_NO != null) {
            this.deleteFlatFileItems.data.push(
              {
                FFL_PRCS_NO: item.FFL_PRCS_NO,
              }
            )
          }

          if (item.MPD_PRCS_NO != ''  &&  item.MPD_PRCS_NO != null) {
            this.deleteMappingDefinitionItems.data.push(
              {
                MPD_PRCS_NO: item.MPD_PRCS_NO,
              }
            )
          }

          if (item.ATF_FILE_CNT > 0) {
            this.deleteReferenceFileItems.data.push(
              {
                REPO_PRCS_NO: item.REPO_PRCS_NO,
              }
            )
          }

        }
      }
      Store.dispatch("repository/deleteRepository", this.deleteRepoItems).then(() => {

        Store.dispatch("map/deleteMap", this.deleteMapperItems).then(() => {
          console.log("--------- Finished to Delete Mappers ----------");
        });
        Store.dispatch("fflayout/deleteFFLayout", this.deleteFlatFileItems).then(() => {
          console.log("--------- Finished to Delete Flatfiles ----------");
        });

        Store.dispatch("mapdefinition/deleteMapDefinition", this.deleteMappingDefinitionItems).then(() => {
          console.log("--------- Finished to Delete Mapping Definition ----------");
        });

        Store.dispatch("referencefile/deleteRepoReferenceFiles", this.deleteReferenceFileItems).then(() => {
          console.log("--------- Finished to Delete Reference Files ----------");
        });

        console.log("--------- Finished to process ----------");
        this.queryList();
        this.selectRepoArr =[];
        this.$refs.deleteRepositorySuccessDialog.dialog = true;
      });
    },
    saveUpdateRow() {
      this.saveUpdateItemsHeader['data'] = [];
      for(let i = 0; i < this.repoList.length; i++) {
        let item = this.repoList[i];
        if (typeof item.SYSSTATUS == 'undefined' || item.SYSSTATUS == '') {
          continue;
        }
        if (item.REPO_SNDR.trim() == '' || item.REPO_RCVR.trim() == '' || item.REPO_MSG_ID.trim() == '') {
          this.$refs.addNewRowEmptyDialog.dialog = true;
          return;
        }
        if (this.isDuplicateSRMItem(item)) {
          this.$refs.addNewRowDuplicateDialog.dialog = true;
          return;
        }
        this.saveUpdateItemsHeader.data.push(
          {
            REPO_PRCS_NO: item.REPO_PRCS_NO,
            MAP_PRCS_NO: item.MAP_PRCS_NO,
            REPO_SNDR: item.REPO_SNDR,
            REPO_RCVR: item.REPO_RCVR,
            REPO_MSG_ID: item.REPO_MSG_ID,
          }
        )
      }
      Store.dispatch("repository/saveList", this.saveUpdateItemsHeader).then(() => {
        console.log("--------- Finished to process ----------");
        $('.repo-list-table .v-scrollbar-wrap').scrollTop(0);
        this.queryList();
      });
    },

    isDuplicateSRMItem(item) {
      for (let i = 0; i < this.repoList.length; i++) {
        let srmitem = this.repoList[i];
        if (item.ROWID == srmitem.ROWID) {
          continue;
        }
        if (item.REPO_SNDR == srmitem.REPO_SNDR && item.REPO_RCVR == srmitem.REPO_RCVR && item.REPO_MSG_ID == srmitem.REPO_MSG_ID) {
          return true;
        }
      }
      return false;
    },

    onFilterRepository(str) {
      // 2021.9.10 203728 SPKA-199 Clear select row
      this.$refs.repo_list_table.clearCurrentRow();
      this.rowCurrentClick = -1;
      let datarows = this.repoListSource;
      let filterBy = {filter : this.searchBy, str : this.search};
      let listResult = [];
      if (filterBy != null) {
        let filter = filterBy.filter;
        let str = filterBy.str;
        if (str.trim() == '') {
          listResult = datarows;
        }
        listResult = datarows.filter(item =>  {
          if(filter == 'all') {
            for (const prop in item) {
              if (typeof item[prop] == 'string') {
                let propValue = item[prop].toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              } else if (typeof item[prop] == 'number') {
                let propValue = item[prop].toString().toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              }
            }
          } else {
            if (typeof item[filter] == 'string') {
              let propValue = item[filter].toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[filter] == 'number') {
              let propValue = item[filter].toString().toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }
          return false;
        });
      }
      Store.commit('repository/repoListFilter', listResult);
    },
    findIndexItem(item, arr, col) {
      let prop = (typeof col == 'undefined') ? 'id' : col;
      let index = arr.findIndex((row) => {
        return row[prop] === item[prop]
      })
      return (index > -1) ? index : null
    },
    openMapListDialog (selectItem) {
      let type = "mapList";
      let item = {
        ROWID : 0,
        item: selectItem
      }
      let indexArrDialog = this.findDialog("mapList_0");
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openAddReferenceFileDialog (rowItem) {
       if (rowItem.SYSSTATUS == 'I'){
        return;
      }
      let type = "addReferenceFile";
      let item = {
        ROWID : 0,
        item: rowItem
      }
      let indexArrDialog = this.findDialog("addReferenceFile_0");
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    downloadAttachFile(srmitem) {
      this.downloadReferenceHeader.data[0].REPO_PRCS_NO = srmitem.REPO_PRCS_NO;
      Store.dispatch("srmlist/downloadAllReferenceFiles", this.downloadReferenceHeader ).then(() => {
        console.log("--------- Finished to process ----------");
      });
    },
    openMapperVersion (itemRow) {
      let type = "mapperVersion";
      let item = {
        ROWID : 0,
        action:'map',
        item:itemRow
      }
      this.mapperVersionHistoryItem = itemRow;
      let indexArrDialog = this.findDialog("mapperVersion_0");
      if (indexArrDialog != null) {
        return;
      }
      this.newDialogMapList(item, type) - 1;
    },
    openScannerVersion (itemRow) {
      let type = "scannerVersion";
      let item = {
        ROWID : 0,
        action:'map',
        item:itemRow
      }
      this.mapperVersionHistoryItem = itemRow;
      let indexArrDialog = this.findDialog("scannerVersion_0");
      if (indexArrDialog != null) {
        return;
      }
      this.newDialogMapList(item, type) - 1;
    },
    openScannerListCheckIn () {
      let type = "scannerCheckIn";
      let item = {
        ROWID : 0
      }
      let indexArrDialog = this.findDialog("scannerCheckIn_0");
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openMapperListCheckIn () {
      let type = "mapperCheckIn";
      let item = {
        ROWID : 0
      }
      let indexArrDialog = this.findDialog("mapperCheckIn_0");
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openLoadFile (data){
      this.prs = {"CUST_ID":"cyberlogitec.com","STR_SNDR":"NDAL","STR_RCVR":"CTCT","MSG_ID":"COPARN","MSG_VER":"UND95B","DAT_TYPE":"UPDT","FR_DAT":"20200615","TO_DAT":"20200715","MSG_CNT":null,"FFL_FILE_NAME":null,"MAP_NAME":"test_add_file_modify","MAP_CONV_TP":"F2E","FFL_FRMT_TP":null,"PRCS_STS":"REPO","LAY_PRCS_NO":"R000000152","SRM_PRCS_NO":"REP0000085","ALIAS":"","ROWID":29};
      let type = "loadFile";
      let item = {
        ROWID : 0,
        data,
        loadFrom:'map'
      }
      let indexArrDialog = this.findDialog("loadFile_0");
      if (indexArrDialog != null) {
        return;
      }
      this.newDialogMapList(item, type) - 1;
    },
    openCodeTableDialog(codeCtg){
      let type = "selectCodeList";
      let item = {
        ROWID : 0,
        codeCtg: this.codeCtg
      }
      let indexArrDialog = this.findDialog("selectCodeList_0");
      if (indexArrDialog != null) {
        return;
      }
      this.newDialogMapList(item, type) - 1;
    },
    selectCodeItem(item){
      let listOb = Object.keys(this.$refs);
      if(listOb.includes('mapperCheckIn') && this.$refs.mapperCheckIn.length >0){
         this.$refs.mapperCheckIn[0].updateSelectCodeTitle(item);
      }
    },
    openReferenceList (selectedItem) {
      let type = "refenrenceFilesList";
      let item = {
        ROWID : 0,
        item: selectedItem
      }
      let indexArrDialog = this.findDialog("refenrenceFilesList_0");
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    loadMapList(item) {
      this.mapFile = item.MAP_NAME;
    },

    deleteSRMRowItem(item) {
      let index = this.findIndexItem(item, this.mainGrid, 'ROWID');
      if (index != null) {
        //this.$nextTick(() => {
          this.mainGrid.splice(index, 1);
        //});
      }
    },

    setRowClassName(index, item) {
      if(item['hidden']) {
        return 'd-none';
      }
    },

    newDialog (item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    newDialogMapList (item, type) {
      return this.dialogs.push(this.generateDialogMapList(item, type));
    },
    reFreshList(){
      this.$refs.mapList[0].queryMapList();
    },
    removeDialog (dialog) {
      let id = dialog.id
      let index = this.findDialog(id)
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1)
      if (this.selected && this.selected.id === id) this.selected = null
    },

    findDialog (id, dialogs) {
      if (!dialogs) dialogs = this.dialogs
      let index = dialogs.findIndex((val) => {
        return val.id === id
      })
      return (index > -1) ? index : null
    },
    generateDialog (item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({id : id});
      this.dialogId++
      let name = 'Dialog ' + id
      let options = {left : 30 * this.dialogId, top : 30 * this.dialogId, item: item.item};
      return { id, name, type, options }
    },
    generateDialogMapList (item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({id : id});
      this.dialogId++
      let name = 'Dialog ' + id
      let options = {left : 30 * this.dialogId, top : 30 * this.dialogId, item: item};
      return { id, name, type, options }
    },
    dialogDragEnd (obj) {
      let index = this.findDialog(obj.id)
      this.$set(this.dialogs[index].options, 'left', obj.left)
      this.$set(this.dialogs[index].options, 'top', obj.top)
    },
    selectDialog (obj) {
      let index = this.findDialog(obj.id)
      this.selected = this.dialogs[index]
    },
    updatedMap(mapItems){
      let {item, selectItem} = mapItems;
      selectItem.MAP_NAME= item.MAP_NAME;
      selectItem.FFL_FILE_NAME = item.FFL_FILE_NAME;
      selectItem.MPD_FILE_NAME = item.MPD_FILE_NAME;
      selectItem.MAP_PRCS_NO = item.MAP_PRCS_NO;
      selectItem.SYSSTATUS = 'U';
    },
    updatedReferenceFiles(referenceFilesItems){
      let {item, selectItem} = referenceFilesItems;
      this.$refs.addReferenceFile[0].addreferenceFileRow(referenceFilesItems);
    },
    rowDoubleClick(index, item, col){
      if(item.REPO_PRCS_STS != "INIT"){
        item.SYSSTATUS='U';
      }else{
        item.SYSSTATUS='';
      }
    },
    //203665 disable day after today
    allowedDates(val){
      let date= getAppliedTimeZone();
      if(val <= date){
        return val;
      }
    },

    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if(this.window.width <= 1920 && this.window.width >= 1280){
        this.tableHeight = 600
        this.componentKey+=1
      }
      else if(this.window.width < 1280 && this.window.width >= 1024){
        this.tableHeight = 360;
        this.componentKey+=1
      }
      else if(this.window.width < 1024){
        this.tableHeight = 200;
        this.componentKey+=1
      }
    }
  },

  created () {
    // By April to Show EDI Asset depending on Authority.
    this.tooltipWidth = cfg.tooltipWidth;
    this.dateTimeFormat = cfg.dateTimeFormat;
    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    this.queryList();
    this.getStatus();
    this.getCustomers();
    this.getDateType();
    this.getCommunication();
  },
  mounted () {
    let a = $('.v-content__wrap');
    this.$nextTick(() => {
      console.log(this.headers);
    })
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
}
</script>


<style>
.action-section.search-bar button.primary {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}
.action-row.btn-form-control .btn-height-custom {
  margin-bottom: 0px !important;
}

.srm-list-container .v-text-field.data-table-filter-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  margin-left: 0px !important;
}
.srm-total-status-section span, .srm-status-stat span {
  vertical-align: bottom;
}
.v-application .srm-list-table .v-table-btable .v-table-row td div span.repo-init-status {
  font-weight: bold;
  color: #606268 !important;
}
.v-application .srm-list-table .v-table-btable .v-table-row td div span.repo-repo-status {
  font-weight: bold;
  color: #309D27 !important;
}
.repo-list-table .v-table-sort-icon {
  visibility: unset !important;
}
.repo-list-table .v-table-sort-icon, .repo-list-table .v-table-sort-icon i{
  height: 14px;
}
.repo-list-table .v-table-sort-icon .checked {
  visibility: visible;
}
.btn-tooltip{
  display: inline-flex;
  margin-right:10px
}
</style>